export default __webpack_public_path__ + "images/U4.714f00c.png";